export default __webpack_public_path__ + "static/ss-cce2b8fc02e11a12df9442377b39bc6c.png";